<datatable2 #datatable [definition]="tableDefinition" [data]="tableData" stickyheaders (rijklik)="edit($event.id)"></datatable2>
<div class="footer">
  <div links>{{ datatable.filterRijen }} / {{ datatable.rijen }} &nbsp; <xls-datatable [datatable]="datatable" btnclass="btn btn-primary" filenaam="Toolboxen" werkblad="Toolboxen"></xls-datatable></div>
  <div rechts><button class="btn btn-success" (click)="nieuw()">Nieuw...</button></div>
</div>
